import type { PasswordOptions } from './generatePassword';
import type { ServiceClassPasswordPolicy } from '@ragu-components/ord-types';

export const fromServiceClassToPasswordOptions = (
  passwordPolicy?: ServiceClassPasswordPolicy
): PasswordOptions | undefined => {
  if (!passwordPolicy) return undefined;
  return {
    maxLength: passwordPolicy.max_length ?? 255,
    minLength: passwordPolicy.min_length ?? 0,
    minLowercase: passwordPolicy.lowercase ?? 0,
    minNumbers: passwordPolicy.numbers ?? 0,
    minSpecials: passwordPolicy.special ?? 0,
    minUppercase: passwordPolicy.uppercase ?? 0,
  };
};
